module.exports = __webpack_public_path__ + "img/R-C.7b1a08b9.jpg";